// ===== Popup: auto-open only once per session =====
(function () {
  var KEY = 'cc_popup_seen';
  var overlay = document.getElementById('popup-overlay');
  if (!overlay) return;

  var seen = false;
  try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  // FIRST page of the session: let main.js auto-open as usual, and record that it opened
  if (!seen) {
    if (overlay.classList.contains('open')) { mark(); return; }

    var obs = new MutationObserver(function () {
      if (overlay.classList.contains('open')) { mark(); obs.disconnect(); }
    });
    obs.observe(overlay, { attributes: true, attributeFilter: ['class'] });
    return;
  }

  // LATER pages: block only the automatic open. The "New Here?" button must still work.
  var userOpened = false;

  // Capture phase: runs before the button's own handler in main.js
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.new-here-coupon-trigger')) {
      userOpened = true;
    }
  }, true);

  function guard() {
    if (!userOpened && overlay.classList.contains('open')) {
      overlay.classList.remove('open');
    }
  }

  new MutationObserver(guard).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  guard();
})();

// ===== Popup lead capture — saves to Shopify customers (isolated, additive) =====
document.addEventListener('DOMContentLoaded', () => {
  try {
    const form = document.getElementById('popup-form');
    if (!form) return;

    form.addEventListener('submit', () => {
      const email = document.getElementById('popup-email')?.value.trim();
      const phone = document.getElementById('popup-phone')?.value.trim();
      if (!email) return;

      const body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'popup-lead');
      if (phone) body.append('contact[note]', `WhatsApp: +91${phone}`);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(err => console.error('Popup lead save failed:', err));
    }, { capture: true });

  } catch (err) {
    console.error('Popup lead capture failed to initialize:', err);
  }
});